import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { ArrowDownIcon } from '@deliveryhero/armor-icons';
import { marginAttributes, paddingAttributes } from '../../../system/attributes';
import { getPropsBlocker, makePropList } from '../../../utils';
import { transitionDurationInSec } from '../../../constants';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
var propertyList = makePropList(['enableExpansionHandle', 'primary', 'secondary', 'tertiary', 'selected', 'expanded', 'tag', 'depthLevel']);

var MenuElementRootWrapper = function MenuElementRootWrapper(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return children(_objectSpread({}, restProps));
};

var getRootDynamicStyle = function getRootDynamicStyle(_ref2) {
  var theme = _ref2.theme,
      enableExpansionHandle = _ref2.enableExpansionHandle,
      secondary = _ref2.secondary,
      tertiary = _ref2.tertiary,
      selected = _ref2.selected;
  var MenuElement = theme.componentOverrides.MenuElement;
  var result = MenuElement.Root.base;

  if (secondary) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, MenuElement.Root.secondary);
  } else if (tertiary) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, MenuElement.Root.tertiary);
  }

  if (enableExpansionHandle) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: 0;\n        "])), result);
  }

  if (selected) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, MenuElement.Root.selected);
  }

  return result;
};

export var MenuElementRoot = styled(MenuElementRootWrapper).withConfig(getPropsBlocker(propertyList, false))(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    position: relative;\n    cursor: pointer;\n    text-decoration: none;\n\n    transition: background-color ", "s ease;\n    &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 0;\n    }\n\n    ", "\n    ", ";\n    ", "\n    ", "\n"])), transitionDurationInSec, getRootDynamicStyle, getComponentOverride('MenuElement'), marginAttributes, paddingAttributes);

var getContentDynamicStyle = function getContentDynamicStyle(_ref3) {
  var theme = _ref3.theme;
  return theme.componentOverrides.MenuElement.Content.base;
};

export var MenuElementContent = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    display: flex;\n\n    ", "\n"])), getContentDynamicStyle);

var getExpansionHandleDynamicStyle = function getExpansionHandleDynamicStyle(_ref4) {
  var theme = _ref4.theme,
      primary = _ref4.primary,
      secondary = _ref4.secondary,
      tertiary = _ref4.tertiary,
      depthLevel = _ref4.depthLevel;
  var MenuElement = theme.componentOverrides.MenuElement;
  var result = MenuElement.ExpanseHandle.base;

  if (primary || !secondary && !tertiary || depthLevel === 0) {
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, MenuElement.ExpanseHandle.primary);
  }

  return result;
};

export var MenuElementExpansionHandle = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    align-self: stretch;\n    cursor: pointer;\n\n    ", "\n"])), getExpansionHandleDynamicStyle);

var getExpansionHandleArrowDynamicStyle = function getExpansionHandleArrowDynamicStyle(_ref5) {
  var expanded = _ref5.expanded,
      theme = _ref5.theme;
  var MenuElement = theme.componentOverrides.MenuElement;
  var result = MenuElement.ExpanseHandleArrow.base;

  if (expanded) {
    result = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            ", ";\n            transform: rotate(180deg);\n        "])), result);
  }

  return result;
};

export var MenuElementExpansionHandleArrow = styled(ArrowDownIcon).withConfig(getPropsBlocker(propertyList, false))(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    transition: transform ", "s ease;\n    transform-origin: center;\n\n    ", "\n"])), transitionDurationInSec, getExpansionHandleArrowDynamicStyle);